<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAnyone :propScreenTitle="screenTitle"></comHeaderAnyone>
    <!-- メイン -->
    <v-main>
      <v-container fluid class="container-12">
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        <v-simple-table class="simple-table">
          <template v-slot:default>
            <tbody>
              <tr v-for="item in desserts" :key="item.name">
                <td class="table-title" >{{ item.name }}</td>
                <td class="table-title-required">
                  <label class="tbl-lbl-blcok required"></label>
                </td>
                <td v-if="item.txtAreaFlg == true" class="table-td-2 pl-1 pt-3">
                  <template>
                     <v-textarea outlined :hint='item.hintChrs' v-model="item.inputval" rows="6" background-color="white"></v-textarea>
                  </template>
                </td>
                <td v-else-if="item.switchFlg == true" class="table-td-2">
                  <template>
                      <v-radio-group v-model="selectedType" row>
                        <!-- <v-radio
                          v-for="(value, key) in pullMapInfo"
                          color="indigo"
                          :key="key"
                          :label="value"
                          :value="key"
                        >
                        </v-radio> -->
                        <v-radio
                          v-for="InquiryKbn in inquiries"
                          color="indigo"
                          :key="InquiryKbn.cd"
                          :label="InquiryKbn.name"
                          :value="InquiryKbn.cd"
                        >
                        </v-radio>
                      </v-radio-group>
                  </template>
                </td>
                <td v-else class="table-td-2">
                  <template>
                      <!-- <v-text-field :placeholder='item.placeholderChrs' dense solo v-model="item.inputval" hide-details="false"></v-text-field> -->
                      <v-text-field label="" outlined :hint='item.hintChrs' dense v-model="item.inputval" ></v-text-field>
                  </template>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- ボタンエリア -->
        <v-row class="mb-5">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <!-- <v-checkbox v-model="agreeCheck">
            </v-checkbox>
            <v-btn plain @click="showPolicyDialog()" class="pa-0 text-subtitle-1" color="blue darken-4">
              <span style="font-weight:bold; text-decoration:underline;">個人情報の取扱い</span>
            </v-btn>
            に同意する -->
          </v-col>
        </v-row >
        <!-- <v-row>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center pb-0">
            <v-checkbox v-model="agreeCheck">
              <template v-slot:label>
                個人情報の取扱いに同意する。
              </template>
            </v-checkbox>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center pt-0">
            <!-- <v-btn :disabled="isProcessing" x-large color="warning" min-width="200px" @click="send()">送信</v-btn> -->
            <v-btn :disabled="isProcessing" x-large color="warning" min-width="200px" @click="showPolicyDialog()">送信</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" min-width="200px" @click="back()">戻る</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-row class="mt-1" style="height: 10vh;"></v-row>
    <!-- フッター -->
    <!-- <comFooterAnyone :contactUsDspFlg="snackbar" :moveTopDspPos="moveTopDspPos" :propSrcScreenId="screenId"></comFooterAnyone> -->
    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
    <comInformation :msg="infoDlgMsg.msg" :isOpen="infoDlgMsg.isOpen" :doYes="infoDlgMsg.doYes" :doNo="infoDlgMsg.doNo" propDialogWidth="90vh" propDialogTitle="個人情報取り扱いについて"/>
  </div>
</template>


<script>
import Constants from '../common/constants';
import Utils from "../common/utils";
export default {
  name: "Inquiry",
  data() {
    return {
      screenTitle: "お問い合わせ",
      screenId: "VPSS400",
      messageArea: "",
      desserts: [
        { name: "氏名", inputval: "", hintChrs: "全角で入力してください。　例）青空　太郎", requiredFlg: true, txtAreaFlg: false, switchFlg: false },
        { name: "氏名（フリガナ）", inputval: "", hintChrs: "全角カナで入力してください。　例）アオゾラ　タロウ", requiredFlg: true, txtAreaFlg: false, switchFlg: false },
        { name: "会社名", inputval: "", hintChrs: "例）株式会社あおぞら", requiredFlg: true, txtAreaFlg: false, switchFlg: false },
        { name: "会社名（フリガナ）", inputval: "", hintChrs: "全角カナで入力してください。　例）アオゾラ", requiredFlg: true, txtAreaFlg: false, switchFlg: false },
        { name: "電話番号", inputval: "", hintChrs: "ハイフンなしの半角数字で入力してください。　例）0123456789", pswdFlg: false, requiredFlg: true, txtAreaFlg: false, switchFlg: false },
        { name: "メールアドレス", inputval: "", hintChrs: "携帯電話のメールアドレスはご利用いただけません。", requiredFlg: true, txtAreaFlg: false, switchFlg: false },
        { name: "メールアドレス（確認）", inputval: "", placeholderChrs: "", requiredFlg: true, txtAreaFlg: false, switchFlg: false },
        { name: "お問い合わせ種類", inputval: "", hintChrs: "お問い合わせ内容の種類を選択してください。", requiredFlg: true, txtAreaFlg: false, switchFlg: true },
        { name: "お問い合わせ内容", inputval: "", hintChrs: "お問い合わせの内容を入力してください。", requiredFlg: true, txtAreaFlg: true, switchFlg: false },
      ],
      selectedType: "",
      inquiries: [{ cd: "", name: "" }],
      agreeCheck: false,
      snackbar: false,
      moveTopDspPos: "",
      isProcessing: false,
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: Constants.MSG_INF_CONTACT_MAIL_SEND_COMPD ,
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
          // this.CloseWindow();
          this.back();
        },
      },
      infoDlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.send();
          this.infoDlgMsg.isOpen = false;
        },
        doNo: () => {
          this.infoDlgMsg.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },

  methods : {
   /*
    * 初期表示
    */
    initialize: function () {
      this.messageArea = this.$i18n.t('webmsg.pss400.area');
      this.getInquiryKbnPullDown();
    },
    showPolicyDialog: function() {
        let polisy = this.$store.getters["terms/getPrivacyPolicy"];
        this.infoDlgMsg.msg = polisy;
        this.infoDlgMsg.isOpen = true;
        return;
    },
    /*
    * 問い合わせプルダウン取得
    */
    getInquiryKbnPullDown : async function() {
      let apiurl = Constants.URL_API_PSS400G01;
      let responseData = null;
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json",
            });
        responseData = response.data  
        this.inquiries = responseData.data.inquiriesList; 
      } catch(error) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm110', ['お問い合わせ種類の取得']);
        this.dlgMsg.isOpen = true;
      }
       // 完了メッセージ表示
      this.showDialogMsgAfterAPICall(this.dlgMsg, responseData); 
    },

    /*
    * 送信ボタン押下
    */
    send: async function () {
      if (this.isProcessing) return;
      this.isProcessing = true;
      // // チェック処理
      // if (!this.agreeCheck) {
      //   this.dlgMsg.msg = this.$i18n.t('msg.err.ps010');
      //   this.dlgMsg.isOpen = true;
      //   this.isProcessing = false;
      //   return;
      // }
      // 問い合わせ登録サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      try {
        let apiurl = Constants.URL_API_PSS400P01;
        // 入力データ
        let data = JSON.stringify(this.createRequestData());
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json",
            }); 
        responseData = response.data;
        console.log(response);
      } catch(error) {
        apiErrorInfo = error;
      } finally {
        this.isProcessing = false;
        this.loading = false;
      }
      // 完了メッセージ表示
      this.showDialogMsg(apiErrorInfo, responseData);
    },
    
    /*
    * 閉じるボタン押下
    */
    // CloseWindow() {
    //   window.close();
    //   return false;
    // },

    /*
    * 戻るボタン押下
    */
    back(){
      // 遷移元画面へ戻る
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "PSS100" }).href);
      } else {
        this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },
    
    /*
    * 登録用リクエストデータ生成
    */
    createRequestData : function() {
      let reqData = {};
      reqData['selectedInquiryTypeList'] = new Array();
      reqData['agreeCheck'] = this.agreeCheck;
      for (const value of this.desserts) {
        switch (value.name) {
          case '氏名':
            reqData['name'] = value.inputval;
            break;
          case '氏名（フリガナ）':
            reqData['nameKana'] = value.inputval;
            break;
          case '会社名':
            reqData['companyName'] = value.inputval;
            break;
          case '会社名（フリガナ）':
            reqData['companyNameKana'] = value.inputval;
            break;
          case '電話番号':
            reqData['phoneNo'] = value.inputval;
            break;
          case 'メールアドレス':
            reqData['mailAddress'] = value.inputval;
            break;
          case 'メールアドレス（確認）':
            reqData['mailAddressConfirm'] = value.inputval;
            break;
          case 'お問い合わせ種類':

            reqData['selectedInquiryType'] = this.selectedType;
            break;
          case 'お問い合わせ内容':
            reqData['detail'] = value.inputval;
            break;
        }
      }
      return reqData;
    },

    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, responseData) {
      let hasError = true;
       // APIコール異常
      if (responseData == null) {
        dialog.msg = this.$i18n.t('msg.err.cm110', ['お問い合わせ種類の取得']);
        dialog.isOpen = true;
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
         return hasError;
      }
    },

    /*
    * 完了メッセージ表示
    */
    showDialogMsg : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm110', ['お問い合わせ']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        }
      }
    },

  },
};
</script>

<style scoped>
.simple-table {
  table-layout: auto;
  width: 96%;
  margin: 40px 20px;
  margin-bottom: 0px;
}
.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
  text-align: left;
}
.table-title-required {
  background-color: #f2f2f2;
  width: 10%;
  text-align: right;
}
.table-td-1 {
  display: flex;
  text-align: left;
  padding: 6px 6px !important;
  background-color: #f2f2f2;
}
.table-td-2 {
  /* display: flex; */
  text-align: left;
  padding: 6px 6px !important;
  /* background-color: #f2f2f2; */
  background-color: #fff;
  height: auto;
}

@media screen and (max-width: 750px) {
  .simple-table {
    table-layout: auto;
    width: 96%;
    margin: 5px 5px;
  }
  .table-title {
    background-color: #f2f2f2;
    width: 34%;
    font-size: 0.9em !important;
    text-align: left;
  }
  .table-title-required {
    background-color: #f2f2f2;
    width: 20%;
    text-align: right;
  }
}
</style>